const GlobalConstants = {
  FILTER_AVAILABLE: 1,
  FILTER_UNAVAILABLE: 0,
  BRAND_UNAVAILABLE: -1,
};

export default GlobalConstants;



/** WEBPACK FOOTER **
 ** ./src/components/GlobalConstants.js
 **/